
declare global {

  interface UIStateDatagridColumn {
    visible?: boolean
    width?: number
  }

  interface UIStateDatagrid {
    columns?: Record<string, UIStateDatagridColumn>
  }

  interface UIState {
    datagrids?: Record<string, UIStateDatagrid>
    save(): void
  }
}

const savedUIState = localStorage.getItem('uiState')
export const uiState: UIState = savedUIState ? JSON.parse(savedUIState) : {}

uiState.datagrids ||= {}
uiState.save = () => localStorage.setItem('uiState', JSON.stringify(uiState))

if (typeof window !== "undefined") {
  window.onbeforeunload = () => {
    uiState.save()
    // the absence of a returnValue property on the event will guarantee the browser unload happens
    return null
  }
}
